import { AuthFrontRoleGuard } from './../helpers/auth-front-role.guard';
import { AppComponent } from './../app.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PublicIndexComponent } from './public-index/public-index.component';
import { PublicHomeComponent } from './public-home/public-home.component';
import { AccountDeactiveComponent } from './account-deactive/account-deactive.component';

const routes: Routes = [
  {
    path: '',
    component: PublicIndexComponent,
    children: [
      { path: '', component: PublicHomeComponent, pathMatch: 'full' },

      {
        path: 'profile',
        loadChildren: () =>
          import('./logged-in/logged-in.module').then((m) => m.LoggedInModule),
        canLoad: [AuthFrontRoleGuard],
        data: { roles: ['Buyer'] },
      },

      {
        path: 'deactivate-account/:email',
        component: AccountDeactiveComponent,
      },

      {
        path: '',
        loadChildren: () =>
          import('./not-logged-in/not-logged-in.module').then(
            (m) => m.NotLoggedInModule
          ),
      },
    ],
  },

  { path: 'activate/:token', component: AppComponent },
  { path: 'user-reset-password/:token', component: AppComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
